"use client"

import { t } from "@/languages/i18n"
import { CaretDownOutlined, CaretUpOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Image, Modal } from "antd"
import Title from "antd/es/typography/Title"
import React, { useState } from "react"
import { ADMIN_API_CONFIG } from "../../../../constants/api-configs"
import { Images } from "../../../../constants/images"
import { MediaData } from "../../../../lib/config/types"
import AddNewMedia from "../../media/pages/AddNewMedia"
import Media from "../../media/pages/Media"

interface FeaturedImageProps {
  selectedMedia: MediaData | null
  setSelectedMedia: (media: MediaData | null) => void
}

const FeaturedImage: React.FC<FeaturedImageProps> = ({ selectedMedia, setSelectedMedia }) => {
  const [isImageVisible, setImageVisible] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSelectMedia = (media: MediaData) => {
    setSelectedMedia(media)
    setIsModalOpen(false)
  }

  return (
    <div className="categories border border-gray-300 rounded-[10px] mb-5">
      <div className="flex justify-between items-center px-4 py-2 border-b">
        <Title level={4} className="!m-0">
          {t("Featured Image")}
        </Title>
        <Button
          onClick={() => setImageVisible(!isImageVisible)}
          className="flex items-center"
          icon={isImageVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        ></Button>
      </div>
      {!isImageVisible || (
        <div className="m-4">
          {selectedMedia === null ? (
            <div className="flex flex-col gap-4 p-2">
              <Image
                src={Images.imgEmpty.src}
                alt="featured"
                className="w-full cursor-pointer "
                preview={false}
                onClick={handleOpenModal}
              />
              <Button variant="outlined" color="primary" icon={<PlusOutlined />} onClick={handleOpenModal}>
                {t("Set Featured Image")}
              </Button>
            </div>
          ) : (
            <div className="flex flex-col gap-4 p-2">
              <Image
                onClick={handleOpenModal}
                src={
                  selectedMedia === null
                    ? ""
                    : selectedMedia.attributes === undefined
                    ? `${ADMIN_API_CONFIG.API_URL}${selectedMedia.url}`
                    : `${ADMIN_API_CONFIG.API_URL}${selectedMedia.attributes?.url}`
                }
                alt="featured"
                className="w-full cursor-pointer"
              />
              <Button color="danger" variant="outlined" onClick={() => setSelectedMedia(null)}>
                {t("Remove Featured Image")}
              </Button>
            </div>
          )}
        </div>
      )}
      <Modal
        open={isModalOpen}
        title={<span className="ml-4">{t("Select Media")}</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{ backgroundColor: isChooseMedia ? "blue" : "initial", color: isChooseMedia ? "white" : "initial" }}
          >
            {t("Select Media")}
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            {t("Upload Media")}
          </Button>
        </div>
        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <AddNewMedia isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export default FeaturedImage
